import '@babel/polyfill'

/////////////////////////////////////////////////////////////////////////////////////////////////// PLUGINS

//////////////////////////////////////////////////////////////// Cookies Message
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

//////////////////////////////////////////////////////////////// Collapse (Accordion)
// import {
//     CollapsePlugin
// } from 'bootstrap-vue'
// Vue.use(CollapsePlugin)

//////////////////////////////////////////////////////////////// Fixed element on scroll
// import Affix from 'vue-affix'
// Vue.use(Affix)

//////////////////////////////////////////////////////////////// Scroll To
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    container: "body",
    duration: 750,
    easing: "ease",
    offset: -120,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
})

//////////////////////////////////////////////////////////////// Bootstrap Modal
import {
    ModalPlugin
} from 'bootstrap-vue'
Vue.use(ModalPlugin)

//////////////////////////////////////////////////////////////// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

//////////////////////////////////////////////////////////////// Bootstrap Tabs
// import {
//     TabsPlugin
// } from 'bootstrap-vue'
// Vue.use(TabsPlugin)

//////////////////////////////////////////////////////////////// Form Validation
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

//////////////////////////////////////////////////////////////// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps/dist/vue-google-maps.js'
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_MAP_KEY_LOCAL
    },
    installComponents: false,
})

//////////////////////////////////////////////////////////////// Vue Parallax
import VueParallaxJs from 'vue-parallax-js'
Vue.use(VueParallaxJs)

//////////////////////////////////////////////////////////////// Counter number animation
import VueNumber from 'vue-number-animation'
Vue.use(VueNumber)

/////////////////////////////////////////////////////////////////////////////////////////////////// COMPONENTS

//////////////////////////////////////////////////////////////// Background Image
import BgImage from './components/bg-image/bg-image.vue'
Vue.component('bgImage', BgImage)

//////////////////////////////////////////////////////////////// Select Dropdown
import vSelect from 'vue-select'
Vue.component('vSelect', vSelect)
vSelect.props.components.default = () => ({
    Deselect: {
        render: createElement => createElement(''),
    },
    OpenIndicator: {
        render: createElement => createElement('i', {
            class: {
                'icon-arrow-medium-down': true
            }
        }),
    },
});

/////////////////////////////////////////////////////////////////////////////////////////////////// DIRECTIVES

//////////////////////////////////////////////////////////////// Gallery Lightbox
// import FancyBox from './directives/fancy-box/fancy-box'
// Vue.directive('fancy-box', FancyBox)
import './imports/jquery'
import '@fancyapps/fancybox'

//////////////////////////////////////////////////////////////// Scrollbar
import Vuebar from 'vuebar'
Vue.directive('vuebar', Vuebar)

//////////////////////////////////////////////////////////////// Scroll Magic
import ScrollMagic from './directives/scroll-magic'
Vue.directive('scroll-magic', ScrollMagic)

/////////////////////////////////////////////////////////////////////////////////////////////////// APP

//////////////////////////////////////////////////////////////// Bit.dev
import CookiesMsg from './components/cookies-msg/cookies-msg.vue'
import SideMenu from './components/side-menu/side-menu.vue'
import BgVideo from './components/bg-video/bg-video.vue'

//////////////////////////////////////////////////////////////// Local
import BookWidget from './book-widget.js'
import BookForm from './book-form.js'
// import HomeSlider from './home-slider.vue'
import VenueCarousel from './venue-carousel.vue'
import CalendarAvailability from './calendar-availability.vue'
import GalleryList from './gallery-list'
import ContactMap from './contact-map'

// import {
//     devices
// } from './imports/utils'

import {
    disableBodyScroll,
    enableBodyScroll,
    // clearAllBodyScrollLocks
} from 'body-scroll-lock';

Vue.prototype.$date = null
Vue.prototype.$timeOfDay = null
Vue.prototype.$timeOfDayReserved = null

var app = new Vue({
    el: '#app',
    components: {
        CookiesMsg,
        SideMenu,
        BgVideo,
        BookWidget,
        BookForm,
        // HomeSlider,
        VenueCarousel,
        CalendarAvailability,
        GalleryList,
        ContactMap
    },
    data() {
        return {
            pageScrolled: false,
            sideMenuOpen: false,
            windowWidth: window.innerWidth,
            lang: null
        }
    },
    methods: {
        onScroll() {
            this.pageScrolled = window.pageYOffset > 0
        },
        onResize() {
            this.windowWidth = window.innerWidth
        },
        toggleSideMenu(action) {

            if (action === 'close') {
                this.sideMenuOpen = true
            } else if (action === 'close') {
                this.sideMenuOpen = false
            }

            console.log('document.querySelector(".side-menu"):', document.querySelector(".side-menu"))

            if (!this.sideMenuOpen) {
                disableBodyScroll(document.querySelector(".side-menu"), {
                    // paddingRightElements: [document.body, document.querySelector('.header')],
                    reserveScrollBarGap: true,
                })
            } else {
                enableBodyScroll(document.querySelector(".side-menu"), {
                    reserveScrollBarGap: true
                })
            }

            this.sideMenuOpen = !this.sideMenuOpen
        },
    },
    created() {
        this.pageScrolled = window.pageYOffset > 0;

        window.addEventListener('scroll', this.onScroll, {
            passive: true
        })

        window.addEventListener("resize", this.onResize, {
            passive: false
        });

        console.log('%c Coded By Freshdesign Team! ', 'background: #000; color: #c9ec01; padding: 10px; font-size: 13px;');
    },
    beforeMount: function () {
        this.lang = this.$el.attributes['lang'].value;
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll)

        window.removeEventListener("resize", this.onResize)
    }
})